export const GET_MODES_ATTEMPT = "GET_MODES_ATTEMPT";
export const GET_MODES_SUCCESS = "GET_MODES_SUCCESS";
export const GET_MODES_ERROR = "GET_MODES_ERROR";

export const CHANGE_KIOSK_MODE_STATUS_ATTEMPT = "CHANGE_KIOSK_MODE_STATUS_ATTEMPT";
export const CHANGE_KIOSK_MODE_STATUS_SUCCESS = "CHANGE_KIOSK_MODE_STATUS_SUCCESS";
export const CHANGE_KIOSK_MODE_STATUS_ERROR = "CHANGE_KIOSK_MODE_STATUS_ERROR";